<template>
<div>
 <!-- Modal CONFIRM -->
    <modalConfirm ref="confirmModal" />

     <!-- Modal MESSAGE -->  
    <modalMessage ref="msgModal"/>

    <product-info class="mt-1 ml-4" v-bind:productId="product.productId"></product-info>   
        <h4 class="ml-4">
          <i class="fas fa-calculator mr-2" aria-hidden="true"></i>
          INSERIMENTO PREZZO DI ACQUISTO,SCONTO,IVA E PREZZO DI VENDITA PRODOTTO
        </h4>
              
      <form v-on:submit.prevent="submit()">
      <div class="">

      <div class="form-row align-items-center">  

        <div class="col-auto mr-1">

          <input-prezzo

              v-model     = "prices.price1"
              :autofocus  = "true"
              :required   = "true"
              label       = "PREZZO DI ACQUISTO"
              :min        = "0.01"
              :max        = "10000"
              :step       = "0.01"
              @input      = "setCostPrice()"
              placeholder = "Inserisci prezzo di acquisto" 
              
            />
          
          

        </div>
   
      <div v-if="inputSconto.length==0" class="col-auto">
        <button type="button" @click="add()" class="btn btn-link">INSERISCI SCONTO</button>
      </div>

    <!-- INPUT SCONTO -->
    <div class="col-auto"
             
        v-for="(item,index) in inputSconto"
        :key="item.id"
      >
        <input-sconto
        
          ref="scontoInputs"
          class   = "mr-1"
          v-model = "item.discount"
          :label  = "item.label"
          :min    = "0"
          :max    = "100"
          @add    = "add()"
          :show-add = "index === inputSconto.length - 1 && inputSconto.length < 3"
        />
      
    </div>

    <div class="col-auto">
      
        <label for="inputVat"><strong>aliquota Iva</strong></label>
        <div class="input-group mb-2">
                <div class="input-group-prepend">
                <div class="input-group-text perc">%</div>
                </div>  
          <input required type="number" class="form-control" placeholder="" v-model="prices.vat">
      
          </div> 
    </div>   
    <div class="col-auto">
      
        
        <label  for="inlineFormInput2">Calcola Ricarico </label>
               <div class="input-group mb-2">
                <div class="input-group-prepend">
                <div class="input-group-text perc">%</div>
                </div>
              <input  type="number" class="form-control " id="mult" placeholder="" v-model="multiplier">
              <button type="button" :disabled="!prices.price1 || !multiplier" @click="setCalc()"  title="Calcola ricarico"  class="btn calc pointer" id="basic-addon1"><i class="fas fa-calculator" aria-hidden="true"></i></button>
                <div class="input-group-append">
                <div class="input-group-text">

                  <span style="font-size: 15px;" class="badge badge-light">Ricarico {{markUp}}</span>

                </div>
                  
            </div>
        
      </div> 
      </div>
      <div class="col-auto">
        <label for="inputPrice2"><strong>PREZZO DI VENDITA</strong></label>
        <div class="input-group mb-2">
                <div class="input-group-prepend">
                <div class="input-group-text euro">€</div>
                </div>  
                <input step="0.01" min="0.01" @input="setMarkUp()" required v-model="prices.price2"  class="form-control"   type="number" v-bind:placeholder="'Prezzo di vendita'">   
                
        </div>
        
        
      </div>
      
     </div>







<priceList  @update="setPriceList" v-bind:product="product" v-bind:costPrice="costPrice" v-bind:retailPrice="retailPrice" v-show="priceTable"></priceList>       
</div>



  <div class="alert alert-warning border border-info" role="alert">
  <div v-if="true" class="form-group form-check mb-3 text-right box-variazione_">
      <input type="checkbox" class="form-check-input" id="exampleCheck1" v-model="flagVariazioneListino">
      <label class="form-check-label pointer" for="exampleCheck1">
       RICORDAMI VARIAZIONE LISTINO DI VENDITA ALLA CONSEGNA
      </label>
  </div>

</div>


<div class="modal-footer d-flex flex-column">

 

  <!-- BOTTONI affiancati -->
  <div class="d-flex justify-content-end">
      <button @click="priceTable = true"
              type="button"
              class="btn btn-secondary mr-3">
        MOSTRA TABELLA PREZZO PER MISURA
      </button>

      <button type="submit" class="btn btn-primary">
        <i class="far fa-save mr-3"></i>
        REGISTRA ORDINE PRODOTTO
      </button>
  </div>

</div>


</form>


  <div v-if="false">
      <h5 class="mb-4">Dati JSON:</h5>
      <pre>{{ inputSconto }} </pre> 
      
    </div>

    </div>


</template>

<script>
import api                   from '@/api' 
import productInfo           from '@/components/product/ProductInfo.vue'
import priceList             from '@/components/order/PriceList.vue'

import { mapGetters }        from 'vuex'

import modalMessage          from '@/components/modalDialog/ModalMessage.vue'         
import modalConfirm          from '@/components/modalDialog/ModalConfirm.vue'

import inputPrezzo           from '@/components/InputCustom/InputPrezzo.vue'
import inputSconto           from '@/components/InputCustom/InputSconto.vue'
import { v4 as uuidv4 }      from 'uuid'
export default {
  
  components: {priceList,productInfo,modalConfirm,modalMessage,inputPrezzo,inputSconto},  
  props: ['product','orderId'],
 
  data () {
  
    return {

     prices     : {}, 
     inputSconto : [],
     discounts  : {},
     multiplier : '',
     markUp     : 0.00,

    
     priceTable  : false,
     costPrice   : 0,
     retailPrice : 0,
     barcodes    : [],
     priceList   : [], 
     msg         : '',
     spinner     : false,
     flagVariazioneListino : false,
     uuid        : ''
    

    }
  },
   directives: 
    {
      focus: {
      // directive definition
        inserted: function (el) {
          el.focus()
         /* el.select()*/
          }
       
      }
    },
  computed: 
    {     
     ...mapGetters(['company']) 
      
    },
          
  mounted()
    {
   
    },

  created()
  {
      
   this.multiplier    = JSON.parse(localStorage.getItem("mult"))   
   this.prices.vat    = this.company.vat
   this.uuid          = uuidv4()
   
  },

  methods: 
  {


   add()
   {
    if(this.inputSconto.length < 3)
    {
      const l = this.inputSconto.length
      const obj = {'label' : l + 1 + '° sconto',discount : 0, id: l + 1 }
      this.inputSconto.push(obj)


       this.$nextTick(() => {
        const inputs = this.$refs.scontoInputs
        if (!inputs || !inputs.length) return

        const lastInput = inputs[inputs.length - 1]
        if (lastInput && lastInput.$el) {
          const inputEl = lastInput.$el.querySelector('input')
          if (inputEl) {
            inputEl.focus()   // mette il focus sull'input
            inputEl.select()  // seleziona tutto il valore
          }
        }
      })

    }
  },
  async saveOrder() 
  {
    const flagVariazioneListino = this.flagVariazioneListino
    const data                  = {...this.getTableBase(this.product.barcodes,this.priceList),flagVariazioneListino} 
    
    const uuid                  = this.uuid  
    const sp                    = 'spInsertSupplierOrderDetailNew'

    const payload   = {'orderId'   : this.orderId, 
                       'productId' : this.product.productId, 
                       'counter'   : this.product.counter, 
                       ...data,                                           
                       sp,
                       uuid

                      }
                      
    this.$refs.msgModal.show('',{'spinner' : true,'title':'ELABORAZIONE IN CORSO ...'})  
    try{

       const res = await api.post(payload)
        
          if (res.status !== 200) 
          {
              throw new Error(res.data ||  res)
          }
            
          

            this.$emit('update')          
    }
    catch(err){
            this.$refs.msgModal.show(err.message)
    }



	},
  

  
  getTableBase(barcodesData, pricesData) {
  
  const costPrices   = pricesData[0].prezzi;
  const retailPrices = pricesData[1].prezzi;
  
  const items = [];

  barcodesData.forEach(item => {
    const colorId        = item.colorId;
    const supplierColor  = item.supplierColor;
    const quantities     = item.quantities;
    const barcodes       = item.barcodes;
    
    Object.keys(quantities).forEach(sizeId => {
      const key       = String(sizeId)
      const qty       = quantities[key]
      if(Number(qty))
      {
        items.push({
          barcode       : barcodes[key],
          ean_13        : '',
          colorId       : colorId,
          supplierColor : supplierColor,
          qty           : quantities[key],
          sizeId        : sizeId,
          costPrice     : costPrices[key],
          retailPrice   : retailPrices[key],
        
        })
      }
    })
  })

  const discounts = this.inputSconto
  .filter(item => item.discount > 0)
  .map((item, index) => ({
    discount : item.discount,
    id       : index + 1   // indice che parte da 1
  }));

  return {items,discounts}
},

    setPriceList(data)
    {
      
      this.priceList = data
    },

    setCostPrice()
    {
      this.costPrice = this.prices.price1
      
    },
    async submit()
    {
      
      
       const confirmed=  await this.$refs.confirmModal.show(
          'REGISTRARE IL NUOVO ORDINE ?',
          { title: 'CONFERMA REGISTRAZIONE' },1
        )

        if (!confirmed) return  
        this.$refs.confirmModal.close()

        this.saveOrder()
      
      

    },
    getDiscountedPrice()
    {
      
        let total = Number(this.prices.price1) || 0;        
        const discounts = this.inputSconto
          
        for (const discount of discounts) {
          // converte in number e verifica se è un valore valido > 0
          const d = Number(discount.discount);
          if (!isNaN(d) && d > 0) {
            total -= (total * d) / 100;
          }
        }

        return total;


    },
    setCalc()
    {
     
      
      const total = this.getDiscountedPrice();
      
      const retailPrice = total + (total * this.multiplier) / 100
      
      this.prices.price2 = retailPrice.toFixed(2);
      localStorage.setItem('mult', JSON.stringify(this.multiplier));
      this.setMarkUp(total)
      
 },
 setMarkUp(price)
 {
  
  let price1 = !price ? this.getDiscountedPrice() : price
  
  this.markUp = 0
  if(Number(price1) > 0 && Number(this.prices.price2) > 0)
  {

    let n = Number(this.prices.price2) / Number(price1)
    this.markUp = n.toFixed(2)
  }

  this.retailPrice = this.prices.price2


 }
        
}
  
}
</script>

<style scoped>



.pointer{
  cursor: pointer;
}


h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
  
}
.euro{
  color             : white ;
  background-color  :  darkgreen;;
}

.calc{
  color: yellow;
  background-color:  #0787ff;;
}
.perc{
  color             : black;
  background-color:  rgb(236, 242, 233);;
}
.form-check-label{
  font-weight: bold;
  color: blueviolet;
}
</style>